export const ChatAgent: React.FC = () => <div data-qa="chat-agent">intro</div>;
